export default __webpack_public_path__ + "media/images/main-adv/events-c94724ffcf013d854e2a9f24f89aec05.svg";